// extracted by mini-css-extract-plugin
export var content = "_9u-3";
export var list = "_9u-4";
export var settingsContent = "_9u-7";
export var settingsPanel = "_9u-8";
export var state = "_9u-6";
export var triggerBadge = "_9u-2";
export var triggerButton = "_9u-1";
export var triggerShell = "_9u-0";
export var unreadDot = "_9u-5";